import { SummarySectionV2, useFeatureToggle } from '@css-xp/base';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { isDeletionPendingEntitlement, isDeletedEntitlement } from '@atlassian/cssxp-utils-entitlement';
import { ENABLE_PRODUCT_DATA_DELETION } from '@atlassian/cssxp-utils-generic';
import React from 'react';
import { ViewDeletedProductDetails } from '../../entitlment-summary-utils';

export const StatusSectionWrapper = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => {
  return (
    <SummarySectionV2.SummaryGridCalloutItem testId="summary-page-status">
      <div className="billing-plan billing-cycle title-height" data-testid="summary-status">
        <label>Status</label>
        {children}
      </div>
    </SummarySectionV2.SummaryGridCalloutItem>
  );
};

export const StatusSection = ({ entitlement }: { entitlement: EntitlementDetails }) => {
  const [isEnabled] = useFeatureToggle();
  const status = [];

  if (
    isEnabled(ENABLE_PRODUCT_DATA_DELETION) &&
    (isDeletionPendingEntitlement(entitlement) || isDeletedEntitlement(entitlement))
  ) {
    status.push(
      <StatusSectionWrapper>
        <div className="entitlement-details-column">
          <span>{isDeletedEntitlement(entitlement) ? 'Deleted' : 'Deletion pending'}</span>
        </div>
        <ViewDeletedProductDetails entitlement={entitlement} />
      </StatusSectionWrapper>
    );
  }

  return <>{status}</>;
};
